import companyIcon from "@assets/icons/company.svg";
import resourcesIcon from "@assets/icons/resources.svg";
import safetyIcon from "@assets/icons/safety.svg";
import partnersIcon from "@assets/icons/partners.svg";
import supplierIcon from "@assets/icons/supplier.svg";

// HEADER DATA
export const navLinks = [
  {
    title: "Partnerships",
    subTitle: "Partnerships & Programs",
    icon: partnersIcon,
    links: [
      {
        title: "Partnerships & Suppliers",
        href: "/partners",
      },
      {
        title: "Business Solutions & Developer Services",
        href: "/partners/business-solutions-and-developer-services",
      },
      {
        title: "Developer & Owner Association (OA) Solutions",
        href: "/partners/developer-and-owner-association-solutions",
      },
    ],
  },
  {
    title: "Supplier Portal",
    subTitle: "Supplier & Vendor Portal",
    icon: supplierIcon,
    links: [
      {
        title: "Supplier & Vendor Portal",
        href: "/partners/supplier-and-vendor-portal",
      },
    ],
  },
  {
    title: "Compliance",
    subTitle: "Safety & Support",
    icon: safetyIcon,
    links: [
      {
        title: "Safety & Emergencies",
        href: "/partners/safety/safety-emergencies",
      },
      { title: "FAQs", href: "/partners/safety/faqs" },
      {
        title: "Safety Guidelines & Emergency Procedures",
        href: "/partners/safety/safety-guidelines",
      },
      {
        title: "Customer Feedback & Service Survey",
        href: "/partners/safety/customer-feedback",
      },
    ],
  },
  {
    title: "Commercial Terms",
    subTitle: "Resources & Compliance",
    icon: resourcesIcon,
    links: [
      {
        title: "Corporate Governance, Compliance & Certifications",
        href: "/partners/resources/corporate-governance",
      },
      {
        title: "Regulatory Compliance & Licensing",
        href: "/partners/resources/regulatory-compliance",
      },
      {
        title: "Downloads & Resources Library",
        href: "/partners/resources/resources-library",
      },
    ],
  },
  {
    title: "Support",
    subTitle: "Company & Investors",
    icon: companyIcon,
    links: [
      { title: "About Us", href: "/partners/about-us" },
      { title: "Why Choose GASIS", href: "/partners/why-choose-gasis" },
      {
        title: "Sustainability & Corporate Responsibility",
        href: "/partners/sustainability",
      },
      { title: "Careers", href: "/partners/careers" },
      {
        title: "News, Updates & Announcements",
        href: "/partners/news",
      },
      { title: "Contact", href: "/partners/contact" },
    ],
  },
];

//Why Partner with GASIS

export const whyPartnerTexts = [
  {
    title: "Certified Operations",
    subtitle:
      "Work with a DCD-approved and ESMA-certified gas service provider",
  },
  {
    title: "Fair & Transparent Procurement",
    subtitle:
      "Clear evaluation criteria and equal opportunity for all vendors.",
  },
  {
    title: "Long-Term Projects",
    subtitle:
      "Residential communities, commercial properties, and industrial sites.",
  },
  {
    title: "On-Time Payments",
    subtitle:
      "Payments issued in line with UAE commercial and regulatory standards.",
  },
  {
    title: "Technical Excellence",
    subtitle:
      "Access to large-scale gas infrastructure, metering, and maintenance projects.",
  },
];

// supplier partner categories

export const categories = [
  "Gas equipment manufacturers",
  "Smart meters, IoT devices & sensors",
  "EPC contractors for LPG/SNG systems",
  "Piping, regulators, and manifold suppliers",
  "Safety and firefighting equipment suppliers",
  "Engineering, design & consultancy firms",
  "Facility management and AMC contractors",
];

// supplier registration requirements

export const requirements = [
  "Valid Trade License (UAE)",
  "Authorized Signatory Documents",
  "ISO Certifications (if applicable)",
  "Technical Datasheets & Compliance Certificates",
  "HSE (Health & Safety) Policies",
  "Third-Party Liability Insurance",
  "Product Warranty Information",
  "Company Profile & Project Portfolio",
];

// procurement and tending process

export const procurementData = [
  {
    title: "Step 1: Registration",
    subtitle: "Submit your company information and supporting documents",
  },
  {
    title: "Step 2: Technical Evaluation",
    subtitle: "Assessment of product quality, certifications, and compliance.",
  },
  {
    title: "Step 3: Commercial Evaluation",
    subtitle:
      "Pricing, delivery capacity, credit terms, and overall competitiveness.",
  },
  {
    title: "Step 4: Approval & Vendor Listing",
    subtitle:
      "Upon approval, supplier is added to the GASIS Approved Vendor List.",
  },
  {
    title: "Step 5: RFQ/Tender Invitations",
    subtitle:
      "Eligible suppliers receive invitations based on category and capability.",
  },
  {
    title: "Step 6: Contract Award",
    subtitle:
      "Eligible suppliers receive invitations based on category and capability.",
  },
];

// Our Corporate Service Portfolio

export const portfolio = [
  {
    id: "01",
    title: "Design & Engineering",
    subtitle:
      "Turnkey design of LPG/SNG gas distribution networks compliant with Dubai Civil Defense and ESMA standards. Includes concept layouts, load calculation, and equipment sizing. ",
  },
  {
    id: "02",
    title: "Supply & Installation",
    subtitle:
      "Procurement and installation of storage tanks, manifolds, pressure regulators, meters, and safety devices. ",
  },
  {
    id: "03",
    title: "Smart Metering & AMI Integration",
    subtitle:
      "Advanced Metering Infrastructure (AMI) for automated reading, consumption analytics, and leak detection. ",
  },
  {
    id: "04",
    title: "Billing & Collection Outsourcing",
    subtitle:
      "GASIS manages tenant invoicing, payments, collection, and remittance — fully compliant with FTA and RERA requirements.",
  },
  {
    id: "05",
    title: "Operations, Safety & Regulatory Support",
    subtitle:
      "Comprehensive maintenance with safety checks, 24/7 emergency response, and full coordination for Civil Defense and ESMA approvals.",
  },
  {
    id: "06",
    title: "Energy Efficiency & Retrofit",
    subtitle:
      "Upgrade of old gas systems with modern components to enhance safety and reduce losses.",
  },
];

// Why Developers & OA Choose GASIS
export const QA = [
  {
    title: "Single Window Solution ",
    subtitle: "One partner from design to daily operations. ",
  },
  {
    title: "Transparent Billing Model ",
    subtitle:
      "Fixed service fee with optional revenue-sharing for billing and collection. ",
  },
  {
    title: "Certified & Licensed ",
    subtitle:
      "Fixed service fee with optional revenue-sharing for billing and collection.",
  },
  {
    title: "Smart Meter Technology",
    subtitle:
      "Fixed service fee with optional revenue-sharing for billing and collection.",
  },
  {
    title: "Regulatory Compliance ",
    subtitle:
      "Fixed service fee with optional revenue-sharing for billing and collection.",
  },
  {
    title: "Customer Experience ",
    subtitle:
      "Fixed service fee with optional revenue-sharing for billing and collection.",
  },
];

//   Flexible Partnership Structures

export const Structures = [
  {
    title: "Turnkey EPC",
    subtitle:
      "GASIS handles full design, supply, installation, and commissioning under fixed-price EPC terms.",
  },
  {
    title: "Operation & Maintenance Contract",
    subtitle:
      "Developer owns assets; GASIS provides maintenance and 24/7 operations. ",
  },
  {
    title: "Build-Operate-Transfer (BOT)",
    subtitle:
      "GASIS invests in infrastructure, operates it, and transfers ownership after a defined term. ",
  },
  {
    title: "Billing & Collection Outsourcing",
    subtitle:
      "GASIS manages meter readings, tenant invoicing, and collection on developer’s behalf.",
  },
];

// Key Industries Served
export const Industries = [
  {
    title: "Real Estate Developers ",
    subtitle: "Residential towers, villa communities",
  },
  {
    title: "Hospitality, Retail and F&B",
    subtitle: "Hotels, resorts, restaurants, cafés, bakeries, malls",
  },
  {
    title: "Government / Public Sector ",
    subtitle: "Schools, hospitals, municipal buildings",
  },
  {
    title: "Industrial Facilities          ",
    subtitle: "Factories, warehouses ",
  },
];

// features

export const features = [
  "Automated readings (daily / monthly) ",
  "Cloud billing dashboard for property managers ",
  "Multi-unit aggregation and individual invoicing",
  "Exportable reports for accounting and VAT filing ",
  "Optional online payment gateway integration ",
];

// Capabilities
export const Capabilities = [
  "Building wide consumption tracking ",
  "Real-time outstanding balances ",
  "Collection performance analytics ",
  "Maintenance SLA tracking ",
  "Downloadable monthly performance pack (PDF/XLS) ",
];

// offerings

export const offerings = [
  "Periodic inspection and preventive maintenance programs ",
  "Pressure testing and leak audits ",
  "Equipment replacement and calibration ",
  "24/7 emergency response with guaranteed SLA (≤ 60 minutes) ",
  "Digital maintenance reports accessible via portal ",
];

// All GASIS corporate operations adhere to:
export const regulations = [
  "UAE Fire & Life Safety Code of Practice (2021) ",
  "Dubai Civil Defense LPG Guidelines",
  "Emirates Authority for Standardization & Metrology (ESMA) ",
  "Federal Tax Authority (FTA) VAT requirements",
];

// Helping You Meet UAE Net Zero 2050 Goals
export const goals = [
  "Smart metering reduces energy waste through real-time visibility. ",
  "Efficient pressure control minimizes gas loss. ",
  "Leak-detection technology improves safety and reduces emissions.",
  "Optional data analytics for carbon-footprint reporting. ",
];

// Add ons

export const addson = [
  "Gas detector installation and monitoring ",
  "Fire-gas integration with BMS ",
  "Annual Civil Defense safety certification ",
];

// Billing & Collection Service Details

export const billingsDetails = [
  {
    title: "Billing & Administration Fee",
    subtitle: "Fixed charge per tenant invoice issued - ",
    note: "Charged: Per invoice",
    color: "#851700",
  },
  {
    title: "Smart Meter Connection Fee",
    note: "Charged: One-time",
    subtitle: "Activation per unit ",
    color: "#C9E0FF",
  },
  {
    title: "Collection & Processing ",
    subtitle: "Payment collection and reconciliation",
    note: "Charged: Monthly",
    color: "#F24D2B",
  },
  {
    title: "Statement of Account / Reporting ",
    subtitle: "Downloadable SOA reports ",
    note: "Charged: Monthly",
    color: "#F24D2B",
  },
  {
    title: "Late Payment Reminder ",
    subtitle: "SMS/email notification system ",
    note: "Charged: As applicable",
    color: "#62636C",
  },
];

// data for developer and bussiness owner page

interface ServiceCard {
  title: string;
  description?: string;
  dataPoints: string[];
  footerNote?: string;
}

export const serviceCards: ServiceCard[] = [
  {
    title: "Engineering Design & Consultancy",
    description: "We provide complete design solutions including:",
    dataPoints: [
      "LPG/SNG network layouts",
      "Load calculations & pressure modeling",
      "Regulator & manifold sizing",
      "Mechanical room design",
      "DCD-compliant engineering drawings",
      "ESMA-approved materials selection",
    ],
    footerNote:
      "Delivered with full documentation ready for Civil Defense approvals.",
  },
  {
    title: "Supply & Installation of Gas Systems",
    description: "Full installation of:",
    dataPoints: [
      "LPG/SNG pipeline network",
      "Manifolds & regulators",
      "Smart meters for each unit",
      "Solenoid valves (for commercial kitchens)",
      "Gas detectors & alarm systems",
      "Mechanical room equipment",
      "Rooftop or ground tanks (if applicable)",
    ],
    footerNote: "All installations follow UAE Fire & Life Safety Code.",
  },
  {
    title: "Commissioning & Third-Party Certification",
    description: "We manage and deliver:",
    dataPoints: [
      "Pressure testing",
      "Leak tests",
      "Functional tests",
      "Load balancing",
      "System performance testing",
      "Third-party inspection (where required)",
      "Final Civil Defense certification",
    ],
    footerNote:
      "A full commissioning dossier is handed over to the developer/OA.",
  },
  {
    title: "Smart Metering & Digital Billing",
    description: "We provide complete sub-metering and billing services:",
    dataPoints: [
      "Smart meter installation",
      "Automated meter reading",
      "Digital customer portal",
      "Monthly billing & collection",
      "Direct billing to tenants",
      "Recovery of operational costs through service fees",
      "Detailed financial reports for Owners/OAs",
    ],
    footerNote: "This eliminates manual meter reading and revenue leakage.",
  },
  {
    title: "Operation & Maintenance (O&M)",
    description: "Our annual maintenance contract (AMC) includes:",
    dataPoints: [
      "Monthly inspections",
      "Quarterly system audits",
      "Annual full safety inspection",
      "Emergency response (24/7)",
      "Pressure regulation tuning",
      "Equipment servicing & calibration",
      "Mechanical room maintenance",
    ],
    footerNote: "Guaranteed SLA for operational uptime.",
  },
  {
    title: "Emergency Response (24/7)",
    description: "Developers and OAs benefit from dedicated emergency support:",
    dataPoints: [
      "Gas leak response within 60–120 minutes",
      "Civil Defense coordination",
      "Full root-cause analysis reports",
      "System restoration & safety clearance",
      "Emergency hotline: 800-GASIS (42747)",
    ],
    footerNote: "Emergency hotline: 800-GASIS (42747)",
  },
];

// Benefits for Developers & Owners Associations

export const Benefits = [
  {
    id: "01",
    title: "Zero Revenue Leakage",
    item: [
      "Smart meters + automated billing ensure accurate consumption measurement.",
    ],
  },

  {
    id: "02",
    title: "No Administrative Burden",
    header: "We handle:",
    item: ["billing", "collections", "customer service", "account management"],
    footer: "Developers and OAs no longer chase payments.",
  },
  {
    id: "03",
    title: "Compliance Guaranteed",
    item: [
      "GASIS manages all safety standards and certification requirements with DCD & ESMA.",
    ],
  },
  {
    id: "04",
    title: "Lower Operational Costs",
    item: [
      "Outsourcing to GASIS reduces maintenance overhead and liability exposure.",
    ],
  },
  {
    id: "05",
    title: "Transparent Financial Reporting",
    item: [],
  },
  {
    id: "06",
    title: "Faster Handover to Tenants",
    item: [],
  },
  {
    id: "07",
    title: "Single-Point Management",
    item: [],
  },
];

// Developer Project Lifecycle

export const Lifecycles = [
  {
    title: "Step 1: Initial Consultation",
    subtitle:
      "Understanding the project, size, expected load, building type, and requirements.",
  },
  {
    title: "Step 2: Engineering & Design Submission",
    subtitle:
      "We prepare and submit full design drawings for authority approval.",
  },
  {
    title: "Step 3: Materials Mobilization",
    subtitle: "All materials sourced from ESMA-certified suppliers.",
  },
  {
    title: "Step 4: Installation & Supervision",
    subtitle: "Network installed to strict safety codes.",
  },
  {
    title: "Step 5: Testing & Commissioning",
    subtitle: "Pressure tests, leak checks, and functional tests completed.",
  },
  {
    title: "Step 6: Civil Defense Sign-Off",
    subtitle: "Full approval and certification granted.",
  },
  {
    title: "Step 7: Smart Meter Installation",
    subtitle: "Individual meters installed for each unit before handover.",
  },
  {
    title: "Step 8: Billing & Operations Start",
    subtitle:
      "Full billing system activated and customers added to the portal.",
  },
];

export interface ProjectType {
  title: string;
  points: string[];
}

export const projectTypes: ProjectType[] = [
  {
    title: "Residential Towers",
    points: [
      "Sub-metering for all units",
      "Community billing",
      "Reliable O&M",
      "Tenant onboarding & move-in support",
    ],
  },
  {
    title: "Mixed-Use Developments",
    points: [
      "Complete load balancing",
      "Retail and F&B integration",
      "Separate billing for different tenant categories",
    ],
  },
  {
    title: "Shopping Malls & Retail Centers",
    points: [
      "High-demand kitchen systems",
      "Gas room design",
      "24/7 emergency coverage",
    ],
  },
  {
    title: "Hotels & Hospitality",
    points: [
      "High-consumption optimization",
      "Continuous monitoring",
      "Custom billing mechanisms",
    ],
  },
  {
    title: "Communities & Compounds",
    points: [
      "Centralized tank systems",
      "Smart metering per villa/townhouse",
      "Network-wide monitoring",
    ],
  },
];

export const relationship = [
  "Monthly meetings",
  "Site visits",
  "Billing review",
  "Maintenance planning",
  "Compliance updates",
];

export const performances = [
  "Total consumption volume",
  "Collections & outstanding amounts",
  "New connections / move-outs",
  "Meter status",
  "Maintenance activities",
  "Safety compliance summary",
  "Financial breakdown",
];

export interface ToolkitItem {
  title: string;
  fileUrl: string;
}

export const developerToolkit: ToolkitItem[] = [
  { title: "Developer Onboarding Pack", fileUrl: "#" },
  { title: "Technical Specifications Manual", fileUrl: "#" },
  { title: "Mechanical Room Standards", fileUrl: "#" },
  { title: "Smart Meter Integration Guide", fileUrl: "#" },
  { title: "DCD Submission Requirements", fileUrl: "#" },
  { title: "ESMA Material Approval List (AML)", fileUrl: "#" },
  { title: "Sample Commissioning Report", fileUrl: "#" },
  { title: "AMC Contract Template", fileUrl: "#" },
];

// supplier and vendor portal data

export interface VendorCategory {
  id: string;
  title: string;
}

export const vendorCategories: VendorCategory[] = [
  { id: "01", title: "Gas equipment and materials" },
  { id: "02", title: "Smart meters, IoT hardware & sensors" },
  { id: "03", title: "Piping, regulators & safety components" },
  { id: "04", title: "LPG/SNG installation contractors" },
  { id: "05", title: "Engineering consultants" },
  { id: "06", title: "Facility management & maintenance contractors" },
  { id: "07", title: "Safety equipment suppliers" },
  { id: "08", title: "EPC contracting firms" },
];

export const criteria = [
  "  Completed Vendor Registration",
  "Compliance Certificates",
  "Technical Evaluation Documents",
  "HSE Manual",
  "Pricing Structure (if required)",
  "Financial Stability Information (optional)",
];

export const evaluationSteps = [
  {
    stage: 1,
    title: "Document Verification",
    subtitle: "Checking validity of trade license, certifications, insurance.",
  },
  {
    stage: 2,
    title: "Technical Evaluation",
    subtitle:
      "Assessment of materials, specs, quality, and regulatory compliance.",
  },
  {
    stage: 3,
    title: "Commercial Evaluation",
    subtitle: "Review of pricing, delivery, terms, and procurement feasibility",
  },
  {
    stage: 4,
    title: "Approval",
    subtitle: "Vendor is added to GASIS Approved Vendor List",
  },
];

export const uploadCenters = [
  "Updated Trade License",
  "New Product Catalogues",
  "Renewed Insurance Policies",
  "Compliance Renewals",
  "Updated Certificates",
  "DCD/ESMA Approvals",
];

export const invitations = [
  "RFQs (Requests for Quotation)",
  "RFPs (Requests for Proposal)",
  "Tender Invitations",
  "Clarification Requests",
  "Procurement Announcements",
];

export const notifications = ["Email", "Portal Dashboard", "SMS (optional)"];

export const statuses = [
  "All fees and tariffs are exclusive of VAT (5%)",
  "Registration status",
  "Pre-qualification progress",
  "Document verification",
  "Next action required",
  "Tender eligibility status",
];

export const conducts = [
  "UAE regulations",
  "Fair business and commercial practices",
  "GASIS procurement ethics",
  "Non-discrimination policies",
  "Anti-bribery & anti-corruption rules",
  "Confidentiality obligations",
  "Health, Safety & Environment (HSE) standards",
];
